import {
  InvestorDeskReport,
  BoardInfo,
  Director,
  ReportType,
  ReportYear,
  FinancialDocument,
  Regulation46Section,
} from "types/models/investorDeskMaster/InvestorDeskMasterApp";

export const GET_INVESTOR_DESK_SECTIONS = "GET_INVESTOR_DESK_SECTIONS";
export const SET_INVESTOR_DESK_SECTION = "SET_INVESTOR_DESK_SECTION";
export const RESET_INVESTOR_DESK_SECTION = "RESET_INVESTOR_DESK_SECTION";

export const GET_BOARD = "GET_BOARD";
export const GET_DIRECTORS = "GET_DIRECTORS";

export interface GetDirectorsAction {
  type: typeof GET_DIRECTORS;
  payload: Director[];
}

export const GET_REPORT_TYPES = "GET_REPORT_TYPES";
export const GET_REPORT_YEARS = "GET_REPORT_YEARS";
export const GET_FINANCIAL_DOCUMENTS = "GET_FINANCIAL_DOCUMENTS";

export const GET_REGULATION46_SECTIONS = "GET_REGULATION46_SECTIONS";
export const GET_REGULATION46_DOCUMENTS = "GET_REGULATION46_DOCUMENTS";

export interface GetInvestorDeskSectionsAction {
  type: typeof GET_INVESTOR_DESK_SECTIONS;
  payload: InvestorDeskReport[];
}

export interface SetInvestorDeskSectionAction {
  type: typeof SET_INVESTOR_DESK_SECTION;
  payload: InvestorDeskReport;
}

export interface ResetInvestorDeskSectionAction {
  type: typeof RESET_INVESTOR_DESK_SECTION;
}

export interface GetBoardAction {
  type: typeof GET_BOARD;
  payload: BoardInfo;
}

export interface GetReportTypesAction {
  type: typeof GET_REPORT_TYPES;
  payload: ReportType[];
}

export interface GetReportYearsAction {
  type: typeof GET_REPORT_YEARS;
  payload: ReportYear[];
}

export interface GetFinancialDocumentsAction {
  type: typeof GET_FINANCIAL_DOCUMENTS;
  payload: FinancialDocument[];
}

export interface GetRegulation46SectionsAction {
  type: typeof GET_REGULATION46_SECTIONS;
  payload: Regulation46Section[];
}

export interface GetRegulation46DocumentsAction {
  type: typeof GET_REGULATION46_DOCUMENTS;
  payload: FinancialDocument[];
}

export type InvestorDeskMasterActionTypes =
  | GetInvestorDeskSectionsAction
  | SetInvestorDeskSectionAction
  | ResetInvestorDeskSectionAction
  | GetBoardAction
  | GetDirectorsAction
  | GetReportTypesAction
  | GetReportYearsAction
  | GetFinancialDocumentsAction
  | GetRegulation46SectionsAction
  | GetRegulation46DocumentsAction;
